module.exports = __webpack_public_path__ + "static/img/save_hover.60faba17.svg";